/* eslint-disable */
import PropTypes from 'prop-types';
import React from 'react';

import {
  IconButton,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { MdDownload, MdSource } from 'react-icons/md';

import { downloadZipFolder } from '../../../../../services/auxiliaryFunctions/functions';
import {
  ButtonsActionsStyled,
  CellBodyStyled,
  CellHeaderStyled,
  TbodyStyled,
} from './TableFolder.styles';

export function TableFolder(props) {
  const {
    data,
    keys,
    headings,
    editActions,
    buttonEditFunction,
    buttonDeleteFunction,
    callbackClickRow = () => {},
  } = props;

  return (
    <TableContainer style={{ marginTop: 16 }}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            {headings.map((heading) => (
              <CellHeaderStyled key={heading}>{heading}</CellHeaderStyled>
            ))}
            {editActions && (
              <CellHeaderStyled key={'action'}>Ações</CellHeaderStyled>
            )}
          </TableRow>
        </TableHead>
        <TbodyStyled>
          {data.map((row, index) => (
            <TableRow key={row.id}>
              <TableCell key={index}>
                <MdSource size={20} />
              </TableCell>
              {keys.map((cell, cellIndex) => (
                <CellBodyStyled
                  key={`cell-${index}-${cellIndex}`}
                  onClick={() => callbackClickRow(data[index])}
                >
                  {row[cell]}
                </CellBodyStyled>
              ))}
              {editActions && (
                <ButtonsActionsStyled>
                  <IconButton
                    className="buttonEdit"
                    onClick={() => downloadZipFolder(row)}
                    size="large"
                  >
                    <MdDownload />
                  </IconButton>
                </ButtonsActionsStyled>
              )}
            </TableRow>
          ))}
        </TbodyStyled>
      </Table>
    </TableContainer>
  );
}

TableFolder.propTypes = {
  data: PropTypes.arrayOf(PropTypes.string).isRequired,
  keys: PropTypes.arrayOf(PropTypes.string).isRequired,
  headings: PropTypes.arrayOf(PropTypes.string).isRequired,
  buttonEditFunction: PropTypes.func,
  buttonDeleteFunction: PropTypes.func,
  callbackClickRow: PropTypes.func,
};
